<template>
  <dialog-layout :open="showDialog" :type="dialogType" :title="dialogTitle" confirmBtnTitle="OK" @close="btnAction()">
    <template #content>{{ $t(dialogMessage) }}</template>
  </dialog-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import DialogLayout from '@/components/layout/DialogLayout'

export default {
  name: 'AlertDialog',
  components: {
    DialogLayout,
  },
  computed: {
    ...mapState({
      dialogTitle: state => state.dialog.title,
      dialogMessage: state => state.dialog.message,
      dialogType: state => state.dialog.type,
      redirect: state => state.dialog.redirect,
      refresh: state => state.dialog.refresh,
    }),
    showDialog() {
      return this.$store.state.dialog.show
    },
  },
  methods: {
    ...mapActions(['hideAlert'], 'dialog'),
    async btnAction() {
      if (this.refresh === true) {
        window.scrollTo(0, 0)
        this.$router.go()
      } else if (this.redirect) {
        if (typeof this.redirect === 'string') {
          if (this.redirect === 'Login') {
            await this.forceLogout(false)
          }
          this.$router.replace({ name: this.redirect })
        } else if (typeof this.redirect === 'object') {
          if (this.redirect.name === 'Login') {
            await this.forceLogout(false)
          }
          this.$router.replace(this.redirect)
        }
      }

      this.hideAlert()
    },
  },
}
</script>
